import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Subtitle2 } from '../../../components/Typography';

import './index.scss';

const TreatmentPageTabs = ({ tabs, onTabChange, activeTab }) => {
  return (
    <div className='treatment-page-tabs'>
      <div className='treatment-page-tabs__headers'>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cx('treatment-page-tabs__button', {
              active: activeTab === tab.id,
            })}
          >
            <Subtitle2>
              <FormattedMessage
                id={`treatment.${tab.label}`}
                defaultMessage={tab.label}
              />
            </Subtitle2>
          </button>
        ))}
      </div>
    </div>
  );
};

TreatmentPageTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onTabChange: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
};

export default TreatmentPageTabs;
